import gql from 'graphql-tag'

export const ATTACHMENT_FRAGMENT = gql`
  fragment Attachment on Asset {
    id
    createdAt
    updatedAt
    name
    fileSize
    mimeType
    type
    preview
    source
    width
    height
    focalPoint {
      x
      y
    }
  }
`

export const ATTACHMENT_TAG_FRAGMENT = gql`
  fragment AttachmentTag on Tag {
    id
    value
  }
`

export const CREATE_ATTACHMENTS = gql`
  mutation CreateAssets($input: [CreateAssetInput!]!) {
    createAssets(input: $input) {
      ...Attachment
      ... on Asset {
        tags {
          ...AttachmentTag
        }
      }
      ... on ErrorResult {
        message
      }
    }
  }
  ${ATTACHMENT_FRAGMENT}
  ${ATTACHMENT_TAG_FRAGMENT}
`

export const DELETE_ATTACHMENTS = gql`
  mutation DeleteAssets($input: DeleteAssetsInput!) {
    deleteAssets(input: $input) {
      result
      message
    }
  }
`

export const CREATE_CONTRACT = gql`
  mutation CreateContract($input: CreateContractInput!) {
    createContract(input: $input) {
      ... on ContractSuccess {
        contract {
          id
          createdAt
          updatedAt
          code
          orderNumber
          startDate
          endDate
          status
          commissionRate
          fileAttachment
          venueId
          merchantId
        }
      }
      ... on CommonErrorResult {
        errorCode
        message
      }
    }
  }
`

export const UPDATE_CONTRACT = gql`
  mutation UpdateContract($input: UpdateContractInput!) {
    updateContract(input: $input) {
      ... on ContractSuccess {
        contract {
          id
          createdAt
          updatedAt
          code
          orderNumber
          startDate
          endDate
          status
          commissionRate
          fileAttachment
          venueId
          merchantId
        }
      }
      ... on CommonErrorResult {
        errorCode
        message
      }
    }
  }
`

export const DELETE_CONTRACT = gql`
  mutation DeleteContract($id: ID!) {
    deleteContract(id: $id) {
      result
      message
    }
  }
`
